module.exports = __webpack_public_path__ + "img/01_u417.94797322.svg";